module.exports = __webpack_public_path__ + "img/add_to_apple_wallet_en.fef8718c.png";